import React from 'react';
import moment from 'moment';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const getRandomColor = () => {
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);
  return {
    backgroundColor: `rgba(${r}, ${g}, ${b}, 0)`,
    borderColor: `rgba(${r}, ${g}, ${b}, 1)`,
  };
};

const RadarChart = ({ data }) => {
  if (!data || !data.length) {
    return <p>No data available</p>;
  }

  const labelsNames = [
    'Préparation  de la  visite', "Connaissance scientifique et l'environement", "Utilisation de l'ADV et remis de visite",
    "L'accroche", 'Le questionnement', 'Argumentaire', 'Points d\'accords', 'Respect Campagne marketing',
    'Ecoute', 'Traitemet des objections', 'Engagement', 'Qualité de la visite', 'Enquête pharmacies', 'Ciblage Médecin'
  ];

  const datasets = data.map((person) => {
    const notationData = labelsNames.map((label) => {
      const item = Object.values(person.items).find((item) => item.title === label);
      return item ? parseInt(item.notation) || 0 : 0;
    });

    const colors = getRandomColor();

    const label = `(${moment(person.duo_date).format("YYYY-MM-DD")})`;

    return {
      label: label,
      data: notationData,
      backgroundColor: colors.backgroundColor,
      borderColor: colors.borderColor,
      borderWidth: 3,
    };
  });

  const chartData = {
    labels: labelsNames,
    datasets,
  };

  const options = {
    scale: {
      ticks: { beginAtZero: true },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ width: '100%', height: '800px' }}>
      <Radar data={chartData} options={options} />
    </div>
  );
};

export default RadarChart;
